import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = { delay: { type: Number, default: 300 } }

  connect() {
    this.debouncedSubmit = this.debounce(this.submit.bind(this), this.delayValue)
  }

  // Called on input changes
  input() {
    this.debouncedSubmit()
  }

  // Submit the form
  submit() {
    // Forms opted into a Turbo Stream response (data-turbo-stream="true")
    // must go through a real form submission so Turbo's Accept header
    // negotiation kicks in — Turbo.visit is a plain GET visit and ignores
    // that attribute entirely.
    if (this.element.dataset.turboStream) {
      this.element.requestSubmit()
      return
    }

    const searchParams = new URLSearchParams(new FormData(this.element))
    const url = `${this.element.action}?${searchParams.toString()}`

    // Use Turbo to visit the URL, which will update the frame
    Turbo.visit(url, {
      action: "replace",
      frame: "amenities"
    })
  }

  // Debounce helper
  debounce(func, wait) {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }
}
